import { RhinoCollectionMeta } from '../../data/collectionMeta';
import { KalturaChannel } from '../objects';

export function processCollectionMeta(channel: KalturaChannel): RhinoCollectionMeta {
  return {
    id: channel.id,
    name: channel.name,
    ...(channel.metaData?.FilterByEntitlementRequired && {
      isFilterByEntitlementRequired: String(channel.metaData.FilterByEntitlementRequired.value) === 'true',
    }),
  };
}
